export default __webpack_public_path__ + "static/media/graySearchIcon.4eae520e.svg";